import { buf2hex } from "./util";

const DataSource = Object.freeze({
    File: "File",
    Dump: "Dump",
});

class FlashContents {
    constructor(data, partial, source) {
        this.partial = partial;
        this.data = data;
        this.shasum = null;
        this.source = source;
        this.timestamp = new Date();
    }

    isFromFile() {
        return this.source === DataSource.File;
    }

    isFromDump() {
        return this.source === DataSource.Dump;
    }

    async updateDigest() {
        let hashBuffer = await crypto.subtle.digest("SHA-1", this.data);
        const hashArray = new Uint8Array(hashBuffer);
        this.shasum = buf2hex(hashArray)
    }

    static async createFromData(data, partial, source) {
        let fc = new FlashContents(data, partial, source);
        await fc.updateDigest();
        return fc;
    }
}

export { FlashContents, DataSource };
